<div [formGroup]="formGroupReference">
  <label class="form-element-label"> {{ labelTranslationNode | translate }}</label>

  <stx-chips
    [class.display-none]="formGroupReference.get(controlName)?.value?.length === 0"
    [itemsList]="formGroupReference.get(controlName)?.value"
    [ariaLabel]="controlName | translate"
    [removable]="true"
    (removeCallback)="onRemoveChip($event, formGroupReference.get(controlName))"
  ></stx-chips>

  <stx-autocomplete-multi-select
    [autoSelectSingleItem]="false"
    [formControlName]="controlName"
    [itemList]="options"
    [id]="controlName"
    [attr.data-testid]="dataTestId || controlName"
  ></stx-autocomplete-multi-select>
</div>
